/**
 * 获取影院品牌列表
 */
export const GET_CINEMA_BRAND_LIST = '/api/movie/brandList';
/**
 * 获取影院电影信息
 */
export const GET_CINEMA_FOR_MOVIE = '/api/movie/cinemaMovieList';
/**
 * 获取电影场次信息
 */
export const GET_MOVIE_SCENE_LIST = '/api/movie/shows';